import type { ServiceAdapter } from "./service";

/** This is shared by webapp and extension, hence putting it inside mirage. */
export class WebKeymapActionsAdapter implements ServiceAdapter {
  checkForUpdates() {
    if (window) window.location.reload();
    return Promise.resolve();
  }
}
